<template>

	<div class="report_container full" v-loading="loading">
		<vxe-grid class="" v-bind="gridOptions" :key="gridKey" v-if="gridOptions"
			@toolbar-button-click="toolbarButtonClickEvent" :ref="reportName+'_list'">
		</vxe-grid>
		<exportTable :ref="exportRef" :forms="forms" :tableColumn="tableColumn" :reportName="reportName"
			:windowName="windowName" :afterexport="afterexport" listType="report" />
		<formwindow :formConfig="formModule" v-if="formwindowShow" @back="formBack" />
	</div>

</template>
<style>

</style>
<style scoped>

</style>
<script>
	import reportBase from '@_system/components/base/report.js'
	import exportMixins from '@_system/components/base/mixins/list/export.js'
	import exportTable from '@_system/components/export/index.vue'
	export default {
		mixins: [reportBase, exportMixins],
		name: 'report',
		props: {

		},
		data() {
			return {
				footerField: [{
					type: 'seq',
					field: 'code',
					title: '汇总',
				}, {
					type: 'field',
					field: 'num',
					toFixed: 0
				}, {
					type: 'field',
					field: 'amount',
					toFixed: 4
				}],
				showFooter: false,
				reportName: 'deliveryerror',
				windowName: '快递赔付',
				pagerConfig: {
					enabled: false,
				},
				loading: false,
				device: window.systemMethods.device(),
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {


		},
		computed: {

		},

		methods: {
			exportdetail() {
				let info = this.$refs[this.reportName + '_list'].getProxyInfo()
				let create_time = info.form.create_time ? info.form.create_time.join(',') : null
				this.$api.deliveryerror.exportdetail({
					create_time: create_time
				}).then((res) => {
					let data = []
					let columns = [{
						field: 'exchange_no',
						title: '售后单编码',
						visible: true,
					}, {
						field: 'trade_no',
						title: '订单编码',
						visible: true,
					}, {
						field: 'originalStorage',
						title: '原发货仓库',
						visible: true,
					}, {
						field: 'originalDelivery',
						title: '快递名称',
						visible: true,
					}, {
						field: 'originalExpress',
						title: '快递编码',
						visible: true,
					}, {
						field: 'realPayment',
						title: '赔付金额',
						visible: true,
					}, {
						field: 'reason_name',
						title: '原因',
						visible: true,
					}]
					res.forEach((item) => {
						data.push({
							exchange_no: item.exchange_no,
							trade_no: item.trade_no,
							originalStorage: item.originalStorage,
							originalDelivery: item.originalDelivery,
							originalExpress: item.originalExpress,
							realPayment: item.realPayment,
							reason_name: item.reason_name
						})
					})


					this.$refs[this.exportRef].exportData({
						data: data,
						columns: columns
					})
					console.log(res)
				})
			}
			// beforeCreateGrid(formConfig, columns, gridOptions){
			// 	let commit_time = this.getQueryParam('commit_time')
			// 	if(commit_time){
			// 		gridOptions.proxyConfig.autoLoad = false
			// 	}
			// },
			// afterCreateGrid(){
			// 	let commit_time = this.getQueryParam('commit_time')
			// 	if(commit_time){
			// 		let info = this.$refs[this.reportName + '_list'].getProxyInfo()
			// 		commit_time = commit_time.split(',')
			// 		commit_time.forEach((item,index)=>{
			// 			commit_time[index] = item*1000
			// 		})
			// 		info.form.commit_time = commit_time
			// 		this.$refs[this.reportName + '_list'].commitProxy('query')
			// 	}
			// }
			// settlement() {
			// 	this.loading = true
			// 	let settlementdata = []
			// 	let fullData = this.$refs[this.reportName + '_list'].getTableData().fullData
			// 	fullData.forEach((item) => {
			// 		if (item.iscommission == 5) {
			// 			settlementdata.push({
			// 				customerid: item.customerid,
			// 				commit_time: item.commit_time,
			// 			})
			// 		}
			// 	})
			// 	this.$api.settlement.settlement({
			// 		settlementdata: settlementdata
			// 	}).then(() => {
			// 		this.$message.success('操作成功')
			// 		this.loading = false
			// 		this.customreload()
			// 	})
			// }
		},
		components: {
			exportTable
		}
	}
</script>